import axios from "axios";
import { apiBaseUrlV1 } from "../utils/constant";

export const createTenant = async (data) => {
  return await axios.post(`${apiBaseUrlV1}`, data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

export const checkDomain = async (data) => {
  return await axios.get(
    `${apiBaseUrlV1}/check_tenant?domain=${
      data?.domain || ""
    }`
  );
};

export const getDemo = async (data) => {
  return await axios.get(
    `${apiBaseUrlV1}/get_demo_taskboard?company_name=${
      data?.company_name
    }&email=${encodeURIComponent(data?.email)}`
  );
};
